import { render, staticRenderFns } from "./ProfileCourseSkeleton.vue?vue&type=template&id=049d6992&scoped=true&"
import script from "./ProfileCourseSkeleton.vue?vue&type=script&lang=js&"
export * from "./ProfileCourseSkeleton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "049d6992",
  null
  
)

export default component.exports